module.exports = __webpack_public_path__ + "static/Testimonial_Andrea_Potratz-a99f7865185005ff59aac1bcf4bde203.png";